var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.item)?_c('div',{},[_c('router-link',{attrs:{"to":{
    name: 'asset', 
    params: {address: _vm.item.nft_address, id: (_vm.item.nft_id)}
    }}},[_c('span',{staticClass:"c"},[_vm._v(_vm._s(_vm.item.nft_name))])])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }